import styled from 'styled-components';
import { Collapse } from 'antd';

import { Colors } from 'services/ColorService';

export const Wrapper = styled.div`
  padding: 24px 32px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
`;

export const PageTitle = styled.h1`
  font-size: 24px;
  font-weight: 700;
  margin: 0;
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

/** A single visually-bounded section card (filters / KPIs / board). */
export const Card = styled.section`
  border: 1px solid #ededed;
  border-radius: 12px;
  background: #fff;
  padding: 16px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
`;

export const CenterLoader = styled.div`
  display: flex;
  justify-content: center;
  padding: 64px 0;
`;

export const EmptyState = styled.div`
  padding: 48px 0;
  text-align: center;
  color: #8c8c8c;
`;

export const RateWarn = styled.span`
  color: ${Colors.WarningDefault};
  margin-left: 6px;
`;

/** Section heading inside rail blocks (to-pay list etc.). */
export const SectionTitle = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #595959;
  margin: 12px 0 8px;
`;

/** A vertical stack of payment chips. */
export const ChipStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

/** Trailing action area inside a chip (mark-paid / reschedule).
 *  Wraps so the status control + action links never overflow the column into
 *  the right rail; stays right-aligned when it drops onto its own line. */
export const ChipActions = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 4px;
  margin-left: auto;
`;

/* ------------------------------------------------------------------ *
 * v4 tabbed layout — «Обзор» agenda + finance rail, «Планирование».   *
 * ------------------------------------------------------------------ */

/** Vertical stack inside each tab pane. */
export const TabBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

/** Overview body: agenda feed (left) + finance rail (right); the rail drops
 *  under the feed on narrow screens. */
export const OverviewGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(300px, 340px);
  gap: 16px;
  align-items: start;

  @media (max-width: 1100px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const OverviewMain = styled.div`
  min-width: 0;
`;

/** RIGHT finance rail — saldo + chart + to-pay, one bounded card. */
export const OverviewRail = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  border: 1px solid #ededed;
  border-radius: 12px;
  background: #fff;
  padding: 16px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
`;

/** The collapsible weekly-forecast card (expanded by default). */
export const ChartCollapse = styled(Collapse)`
  &.ant-collapse {
    border: 1px solid #ededed;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
    overflow: hidden;
  }
  & > .ant-collapse-item {
    border-bottom: none;
  }
  & > .ant-collapse-item > .ant-collapse-header {
    font-weight: 600;
  }
`;
